"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var updateQueryParams_1 = __importDefault(require("./updateQueryParams"));

var updateQueryParam = function updateQueryParam(key, value, url) {
  var _a;

  if (url === void 0) {
    url = window.location.href;
  }

  return updateQueryParams_1.default((_a = {}, _a[key] = value, _a), url);
};

exports.default = updateQueryParam;